import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NavBar;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import { IconQuizLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/es/format-message';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var NavBar = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NavBar = /*#__PURE__*/function (_Component) {
  function NavBar() {
    var _this;
    _classCallCheck(this, NavBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NavBar, [].concat(args));
    _defineProperty(_this, "hiddenActionItemsMenuTriggerLabel", function (hiddenChildrenCount) {
      return t('{hiddenChildrenCount} more actions', {
        hiddenChildrenCount: hiddenChildrenCount
      });
    });
    _defineProperty(_this, "hiddenMenuItemsMenuTriggerLabel", function (hiddenChildrenCount) {
      return t('{hiddenChildrenCount} More', {
        hiddenChildrenCount: hiddenChildrenCount
      });
    });
    _defineProperty(_this, "renderBrand", function () {
      if (!_this.props.styles.showBrandIcon) {
        return null;
      }
      return jsx(TopNavBar.Brand, {
        screenReaderLabel: t('Quizzes'),
        renderIcon: jsx(IconQuizLine, {
          color: "primary",
          size: "small"
        })
      });
    });
    _defineProperty(_this, "renderMenuItems", function () {
      return jsx(TopNavBar.MenuItems, {
        listLabel: t('Page navigation'),
        currentPageId: window.location.pathname,
        renderHiddenItemsMenuTriggerLabel: _this.hiddenMenuItemsMenuTriggerLabel
      }, _this.props.menuItems.map(function (menuItem) {
        return _this.renderMenuItem(menuItem);
      }));
    });
    _defineProperty(_this, "renderMenuItem", function (menuItem) {
      return jsx(TopNavBar.Item, {
        id: menuItem.path,
        key: menuItem.path,
        onClick: function onClick() {
          return _this.props.handleMenuItemChange(menuItem.path);
        }
      }, menuItem.text);
    });
    _defineProperty(_this, "renderActionItems", function () {
      return jsx(TopNavBar.ActionItems, {
        listLabel: t('Actions'),
        renderHiddenItemsMenuTriggerLabel: _this.hiddenActionItemsMenuTriggerLabel
      }, _toConsumableArray(_this.props.actionItems));
    });
    return _this;
  }
  _inherits(NavBar, _Component);
  return _createClass(NavBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return jsx(TopNavBar, {
        breakpoint: this.props.styles.phoneBreakPoint,
        mediaQueryMatch: "element",
        inverseColor: true
      }, function () {
        return jsx(TopNavBar.Layout, {
          themeOverride: _objectSpread(_objectSpread({
            desktopBackgroundInverse: _this2.props.styles.backgroundColor,
            smallViewportBackgroundInverse: _this2.props.styles.backgroundColor
          }, !_this2.props.styles.desktopBottomBorder ? {
            desktopBottomBorder: false
          } : {}), !_this2.props.styles.desktopBottomBorderInverse ? {
            desktopBottomBorderInverse: false
          } : {}),
          navLabel: t('Quizzes navigation bar'),
          smallViewportConfig: {
            dropdownMenuToggleButtonLabel: t('Toggle Menu'),
            dropdownMenuLabel: t('Main Menu')
          },
          renderBrand: _this2.renderBrand(),
          renderMenuItems: _this2.renderMenuItems(),
          renderActionItems: _this2.renderActionItems()
        });
      });
    }
  }]);
}(Component), _defineProperty(_NavBar, "displayName", 'NavBar'), _defineProperty(_NavBar, "componentId", "Quizzes".concat(_NavBar.displayName)), _defineProperty(_NavBar, "propTypes", {
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })),
  handleMenuItemChange: PropTypes.func,
  actionItems: PropTypes.arrayOf(PropTypes.node),
  styles: PropTypes.object
}), _defineProperty(_NavBar, "defaultProps", {
  menuItems: [],
  handleMenuItemChange: function handleMenuItemChange() {},
  actionItems: []
}), _NavBar)) || _class);
export default NavBar;